import styled from 'styled-components';

export interface ResolutionProps {
    width: number;
    height: number;
}

export const Wrapper = styled.div<ResolutionProps>`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    > .content {
        transform-origin: top left;
        transform: scale(1);
        width: ${(props) => props.width}px;
        height: ${(props) => props.height}px;
      
    }
`;